import { ca } from '@cian/analytics';

export const trackProfessionalSearchClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'Click',
    label: 'ListingLK',
  });
};
